__turbopack_context__.v({
  "intro": "homeSection-module-scss-module__ZoFIEG__intro",
  "introAnimation": "homeSection-module-scss-module__ZoFIEG__introAnimation",
  "introAnimationContainer": "homeSection-module-scss-module__ZoFIEG__introAnimationContainer",
  "introContainer": "homeSection-module-scss-module__ZoFIEG__introContainer",
  "introContent": "homeSection-module-scss-module__ZoFIEG__introContent",
  "introDescription": "homeSection-module-scss-module__ZoFIEG__introDescription",
  "introPattern": "homeSection-module-scss-module__ZoFIEG__introPattern",
  "introTitle": "homeSection-module-scss-module__ZoFIEG__introTitle",
  "support": "homeSection-module-scss-module__ZoFIEG__support",
  "supportStamp": "homeSection-module-scss-module__ZoFIEG__supportStamp",
});
